import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { navActions } from '../Navigation/reducer.esm.js';
import { useNavigationContext } from '../NavigationContext/NavigationContext.esm.js';
import { classNames } from '@panwds/react-ui';

function Logo({ addClassName, logoUrl, logo, fullName, isTwoLines, }) {
    const { collapsed, dispatch, openedNav } = useNavigationContext();
    const intl = useIntl();
    const history = useHistory();
    return (React.createElement("a", { "data-testid": "logo", href: logoUrl, onClick: (event) => {
            event.preventDefault();
            history.push(logoUrl);
            collapsed && dispatch({ type: navActions.toggleCollapse });
        }, style: { height: isTwoLines ? "76px" : "66px" }, className: "tw-box-border tw-border-0 tw-m-0 tw-p-0 tw-underline-none tw-cursor-pointer focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500" },
        React.createElement("img", { src: collapsed || openedNav ? logo : fullName, style: { height: isTwoLines ? "76px" : "66px" }, alt: intl.formatMessage({ id: "ltEZ52", defaultMessage: [{ type: 0, value: "Logo Icon" }] }), className: classNames("tw-box-border tw-border-0", addClassName) })));
}

export { Logo };
//# sourceMappingURL=Logo.esm.js.map
